/* Silent Valor CARGO PDP, M6b "The CARGO on Camera" reel strip (2026-10-19).
   Each reel carries a timeline (seconds:key) read off its export; the detail list follows the active reel
   and a tap on an item seeks that reel to its card. One reel plays at a time: muted autoplay only while half
   the active player is on screen, none under prefers-reduced-motion. Replaces sv-compartments.js. */
(function () {
  var root = document.querySelector('[data-sv-reels]');
  if (!root) return;
  var track = root.querySelector('.sv-reels__track');
  var reels = Array.prototype.slice.call(root.querySelectorAll('.sv-reel'));
  var details = Array.prototype.slice.call(root.querySelectorAll('.sv-reel-detail'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('.sv-reels__chip'));
  var count = root.querySelector('.sv-reels__count');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active = 0, userPaused = false, scrollTimer = null, programmatic = false;

  function parseTimeline(s) {
    return s.split(',').map(function (p) { var a = p.split(':'); return { t: parseFloat(a[0]), key: a[1] }; });
  }
  var R = reels.map(function (el, i) {
    var v = el.querySelector('video');
    return { el: el, v: v, play: el.querySelector('.sv-reel__play'), snd: el.querySelector('.sv-reel__sound'),
             timeline: parseTimeline(el.getAttribute('data-timeline')), end: parseFloat(el.getAttribute('data-end')),
             detail: details[i], items: Array.prototype.slice.call(details[i].querySelectorAll('[data-key]')) };
  });

  function load(r) { if (!r.v.getAttribute('src')) r.v.setAttribute('src', r.v.getAttribute('data-src')); }
  function start(r) { load(r); var p = r.v.play(); if (p && p.catch) p.catch(function () { r.play.hidden = false; }); }
  function mark(r) {
    var t = r.v.currentTime, cur = null, seen = {}, end = t >= r.end;
    r.timeline.forEach(function (e) { if (t + 1e-3 >= e.t) { if (cur) seen[cur] = true; cur = e.key; } });
    r.items.forEach(function (b) {
      var k = b.getAttribute('data-key'), on = !end && k === cur;
      b.classList.toggle('is-active', on);
      b.classList.toggle('is-done', end || (!on && !!seen[k]));
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    var modes = r.detail.querySelectorAll('.sv-mode');
    Array.prototype.forEach.call(modes, function (m) {
      var on = !!m.querySelector('.sv-step.is-active'), done = !on && !!m.querySelector('.sv-step.is-done');
      m.classList.toggle('is-active', on); m.classList.toggle('is-done', done || end);
    });
  }
  function seek(r, t) {
    var go = function () { r.v.currentTime = t + 0.05; mark(r); userPaused = false; start(r); };
    load(r);
    if (r.v.readyState >= 1) go(); else r.v.addEventListener('loadedmetadata', go, { once: true });
  }
  function center(i) {
    var el = R[i].el; programmatic = true;
    track.scrollTo({ left: el.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    setTimeout(function () { programmatic = false; }, 600);
  }
  function activate(i, scroll) {
    if (i < 0 || i >= R.length) return;
    // leaving a reel drops its src: a paused download stays open on the shared CDN connection and, with a few of
    // them, holds back the next reel's video (2026-11-02, reel 4 sat ~10 s on its poster). Revisits restart.
    if (i !== active) { var o = R[active]; o.v.pause(); if (o.v.getAttribute('src')) { o.v.removeAttribute('src'); o.v.load(); } }
    active = i;
    R.forEach(function (r, j) {
      r.el.classList.toggle('is-active', j === i);
      r.detail.classList.toggle('is-active', j === i);
      chips[j].classList.toggle('is-active', j === i);
      chips[j].setAttribute('aria-pressed', String(j === i));
    });
    if (count) count.textContent = (i + 1) + ' / ' + R.length;
    if (scroll !== false) center(i);
    if (!reduce && !userPaused && R[i].v.paused && !R[i].v.ended) start(R[i]);
  }

  R.forEach(function (r, i) {
    r.v.addEventListener('timeupdate', function () { mark(r); });
    r.v.addEventListener('seeked', function () { mark(r); });
    r.v.addEventListener('play', function () { r.play.hidden = true; });
    r.v.addEventListener('pause', function () { r.play.hidden = false; });
    r.v.addEventListener('ended', function () { r.play.setAttribute('aria-label', 'Replay video'); r.play.hidden = false; });
    r.el.addEventListener('click', function (e) {
      if (e.target === r.snd || e.target === r.play || r.play.contains(e.target)) return;
      if (i !== active) { activate(i); return; }
      if (r.v.paused) { userPaused = false; if (r.v.ended) r.v.currentTime = 0; start(r); } else { userPaused = true; r.v.pause(); }
    });
    r.play.addEventListener('click', function () { userPaused = false; if (r.v.ended) r.v.currentTime = 0; r.play.setAttribute('aria-label', 'Play video'); start(r); });
    r.snd.addEventListener('click', function () {
      r.v.muted = !r.v.muted;
      r.snd.setAttribute('aria-pressed', String(!r.v.muted));
      r.snd.textContent = r.v.muted ? 'Tap for sound' : 'Sound on';
      if (r.v.paused && !r.v.ended) { userPaused = false; start(r); }
    });
    r.items.forEach(function (b) {
      b.addEventListener('click', function () {
        if (i !== active) activate(i);
        var rect = r.el.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) r.el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        seek(r, parseFloat(b.getAttribute('data-t')));
      });
    });
  });
  chips.forEach(function (c, i) { c.addEventListener('click', function () { activate(i); }); });
  Array.prototype.forEach.call(root.querySelectorAll('.sv-reels__arrow'), function (a) {
    a.addEventListener('click', function () { activate(active + parseInt(a.getAttribute('data-dir'), 10)); });
  });
  // a horizontal flick on the strip switches reels even where the native scroll does not move (touch on a video)
  var tx = null, ty = null, tt = 0;
  track.addEventListener('touchstart', function (e) { var t = e.touches[0]; tx = t.clientX; ty = t.clientY; tt = Date.now(); }, { passive: true });
  track.addEventListener('touchend', function (e) {
    if (tx === null) return;
    var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty; tx = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5 && Date.now() - tt < 800) activate(active + (dx < 0 ? 1 : -1));
  }, { passive: true });
  // a swipe lands on a reel: the one whose left edge is nearest the track's scroll position becomes active
  track.addEventListener('scroll', function () {
    if (programmatic) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      var left = track.scrollLeft, best = 0, d = Infinity;
      R.forEach(function (r, i) { var dd = Math.abs(r.el.offsetLeft - left); if (dd < d) { d = dd; best = i; } });
      if (best !== active) activate(best, false);
    }, 120);
  }, { passive: true });

  if (reduce || !('IntersectionObserver' in window)) { R[active].play.hidden = false; return; }
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var r = R[active];
      if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!userPaused && !r.v.ended && r.v.paused) start(r); }
      else if (!r.v.paused) r.v.pause();
    });
  }, { threshold: [0, 0.5] }).observe(track);
})();
